import { Controller } from "stimulus"

###
  Wrap a form group containing a datepicker (set it as a target) to enable
  buttons that will set or clear the date.

  Create a button with data-action="datepicker-actions.clear" to clear
    the datepicker.

  Create a button with text containing jQuery-compatible strings as the
    innerText (-30d, -2m, Today) to assign that value to the datepicker
    on click (with data-action="datepicker-actions.setToText")
###
export default class extends Controller
  @targets: ['datepicker']

  setToText: (event) ->
    event.preventDefault()
    $(@datepickerTarget).datepicker "setDate", event.currentTarget.innerText

  clear: (event) ->
    event.preventDefault()
    $(@datepickerTarget).datepicker "setDate", null
